import ReportsListSection from 'modules/ai_reports/components/ReportsListSection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ReportsListPage = () => {
  return (
    <ResponsivePage.Body variant="fullscreen">
      <ReportsListSection />
    </ResponsivePage.Body>
  )
}

export default ReportsListPage
